export default function SignupController() {

}